import {
  UpdateBookingConfigurationsRequestParams,
  UpdateBookingConfigurationsLinkResponse,
} from '../types';

export function updateBookingConfigurations({
  apiClient,
  merchantId,
  paymentAvailability,
}: UpdateBookingConfigurationsRequestParams): Promise<UpdateBookingConfigurationsLinkResponse> {
  const payload = {
    customer_payment: paymentAvailability,
  };
  return apiClient.bookingConfigsV2.update(merchantId, payload);
}
